import { render } from "./Docs.vue?vue&type=template&id=864d534e&scoped=true"
import script from "./Docs.vue?vue&type=script&lang=js"
export * from "./Docs.vue?vue&type=script&lang=js"

import "./Docs.vue?vue&type=style&index=0&id=864d534e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-864d534e"]])

export default __exports__